// Les sons d'un événement de puzzles. `pick` : la pièce sortie du coffre ; `land` : la pièce
// qui s'enclenche ; `done` : le puzzle fini. Les fichiers commencent sans silence : le son part
// à l'instant voulu. Un événement peut donner les siens dans son bloc (theme.sounds) ; ceux
// qu'il ne donne pas restent ceux-ci.
const DEFAULTS = {
    pick: "/static/sounds/pick-piece-puzzles.mp3",
    land: "/static/sounds/put-piece-puzzles.mp3",
    done: "/static/sounds/completed-puzzles.mp3",
};

export const eventSounds = (event) => ({ ...DEFAULTS, ...(event?.theme?.sounds || {}) });
